import culture from "./Assets/Images/culture.jpeg";
import mountain from "./Assets/Images/mountain.jpg";
import nature from "./Assets/Images/mountain.jpg";
import contrast from "./Assets/Images/contrast.jpg";
import religious from "./Assets/Images/religious.jpg";

const CarouselImageData = [
  {
    id: 1,
    img: mountain,
    h4: "discover",
    p: "The Magnificent Himalayas & Karakoram Ranges",
  },
  {
    id: 2,
    img: culture,
    h4: "discover",
    p: "The Fascinating Cultures and Colors of the Land",
  },
  {
    id: 3,
    img: nature,
    h4: "discover",
    p: "The Surreal and Enchanting Glory of Nature",
  },
  {
    id: 4,
    img: contrast,
    h4: "discover",
    p: "The Contrast of Spellbinding Grandeur and Sheer Simplicity",
  },
  {
    id: 5,
    img: religious,
    h4: "discover",
    p: "The Most Spritutal and Ancient Places",
  },
];

export default CarouselImageData;
